import { createFileRoute } from '@tanstack/react-router';

import { NegotiationCostBreakdownOverviewPage } from '@/areas/cost-breakdown/CostBreakdown/NegotiationCostBreakdown/NegotiationCostBreakdownOverviewPage';
import { isInternalUser } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute(
    '/_authenticated/next/negotiations/$negotiationId/_sidebar/scenarios/$sourcingScenarioId/cost-breakdown/',
)({
    staticData: { access: { permissions: isInternalUser }, chrome: 'none' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const pathParams = Route.useParams();
    return <NegotiationCostBreakdownOverviewPage {...pathParams} />;
}
